export function detectBrowser() {
  const { detect } = require('detect-browser');
  const browser = detect();
  if (
    (browser.name === 'ie') & (browser.version >= '11.0.0') ||
    (browser.name === 'firefox') & (browser.version >= '38.0')
  ) {
    return false;
  } else {
    return true;
  }
}
